import Vue from 'vue';
import Vuex from 'vuex';
import notificaciones from '@/store/modules/notificaciones';
import menu from '@/store/modules/menu';

Vue.use(Vuex);

export const store = new Vuex.Store({
    modules: {
        notificaciones,
        menu
    }
});